const getCartToken = async () => {
  try {
    const response = await window.Cart.cartToken();

    return response.token;
  } catch (e) {
    return;
  }
};

async function setCartToken() {
  /**
   * @type {HTMLInputElement | null}
   */
  const input = document.querySelector('[name="attributes[__cartTokenId]"]');

  if (!input) {
    return;
  }

  const token = await getCartToken();
  input.value = token;
}

setCartToken();
